<template>
  <div class="popup" v-if="showPopUp">
    <div
      class="mask fade"
      @click="close"
      :class="{
        'fade-in': showPopUp && inAnimate,
        'fade-out': showPopUp && !inAnimate
      }"
    ></div>
    <div
      class="content-container fade"
      :class="[
        {
          'fade-up': showPopUp && inAnimate,
          'fade-down': showPopUp && !inAnimate
        },
        styleType
      ]"
    >
      <div class="list" :class="{ 'show-close-btn': showCloseBtn }">
        <label for="radio_select" v-if="showDefaultSelectd">
          <div class="item" :class="styleType">
            <div class="title">{{ defaultSelected }}</div>
            <input
              type="radio"
              id="radio_select"
              name="radio_select"
              v-model="radio_select"
              :value="defaultSelected"
            />
          </div>
        </label>

        <div
          class="item"
          v-for="(item, index) in list"
          @click="select(item)"
          :key="index"
        >
          <div class="title">{{ item[indexName] }}</div>
          <input
            type="radio"
            name="radio_select"
            v-model="radio_select"
            :value="item"
          />
        </div>
      </div>
      <div class="close-btn" v-if="showCloseBtn" @click="close">关闭</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BankCardListPopUp",
  props: {
    // 列表数组
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    // 默认选项显示文字
    defaultSelected: {
      type: String,
      default: "请选择"
    },
    // 是否显示默认选项
    showDefaultSelectd: {
      type: Boolean,
      default: true
    },
    // 样式类型
    styleType: {
      type: String,
      default: "bankcard"
    },
    // 键名字段
    indexName: {
      type: String,
      default: "bank_name"
    },
    // 是否显示关闭按钮
    showCloseBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      radio_select: {},
      showPopUp: false,
      inAnimate: false,
      timer: null
    };
  },
  mounted() {
    console.log(this.radio_select);
    this.radio_select = this.defaultSelected;
  },
  methods: {
    select(item) {
      this.radio_select = item;
      this.$nextTick(() => {
        this.$emit("select", this.radio_select);
        setTimeout(() => {
          this.close();
        }, 300);
      });
    },
    open() {
      this.showPopUp = true;
      this.$nextTick(() => {
        setTimeout(() => {
          this.inAnimate = true;
        });
      });
    },
    close() {
      this.inAnimate = !this.inAnimate;
      this.$nextTick(() => {
        if (!this.inAnimate) {
          this.timer = setTimeout(() => {
            this.showPopUp = false;
          }, 500);
        } else {
          clearTimeout(this.timer);
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.popup {
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 666;
  top: 0;
  left: 0;
  .content-container {
    border-radius: 0.2rem 0.2rem 0 0;
    position: absolute;
    z-index: 666;
    background-color: #ffffff;
    bottom: 0;
    left: 0;
    height: 70%;
    width: 100%;
    padding: 0 0.6rem;
    &.refund {
      padding: 0.2rem 0.32rem;
    }
    .list {
      overflow-y: scroll;
      height: 100%;
      width: 100%;
      .item {
        color: #333;
        font-size: 0.32rem;
        padding: 0.28rem 0;
        border-bottom: 1px solid #f0f0f0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        input[type="radio"] {
          transition: all 0.3s;
          width: 0.4rem;
          height: 0.4rem;
          border-radius: 50%;
          border: 0.02rem solid #f0f0f0;
          box-sizing: border-box;
          &:checked {
            border: 0.1rem solid #008bff;
          }
        }
      }
    }
    .list.show-close-btn {
      height: 80%;
    }
    &.refund {
      .list .item {
        font-size: 0.28rem;
        font-weight: 500;
        border-bottom: none;
        input[type="radio"]:checked {
          background-color: #ec5d59;
          border-color: #ec5d59;
          background-size: 0.21rem 0.15rem;
          background-repeat: no-repeat;
          background-position: 50%;
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAATCAYAAACDW21BAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3JpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpiNGYzOTVkMi02NGNjLWJlNDEtYmYxNy1kOWQwYzAzMTU0NzYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QzVGMjYwQkY2NjEyMTFFODgwNkNCNjc3NTI5RjVEMEEiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QzVGMjYwQkU2NjEyMTFFODgwNkNCNjc3NTI5RjVEMEEiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDplZGM0NTZjOS04Zjc2LWVlNGUtYWE1NS0zYjUyMjAzNmI2MGUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6YjRmMzk1ZDItNjRjYy1iZTQxLWJmMTctZDlkMGMwMzE1NDc2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+gW1O6gAAAOZJREFUeNpi/P//PwMdQAkQFwDxPAaQhTTGDf+RAK0tq/2PCqbQ0rJmNMtmgKOPTpZNh8nRwrImNMumIctT27J29DhDVwMiDKESLlQOxinY1IGIP0iKfMm0rAvNsom41IKI/WiKg0i0rBtNfzc+9SCCBYiPo2kKJNKyHjR9fYT0IHMOomkOJaB5Apr6DmIciS5wDM2QYBwa+0gJRkLZAj1Ow9HkJ6PJt5MS57gkDqMZ6g0V70cTbyU1ReOT3Idk8F8g3k6pZcSUNOjBCwNN5BYQxCjaRy3LSClLVwPxSyCupLS8BQgwAKbHULmZN2MuAAAAAElFTkSuQmCC);
        }
      }
      .close-btn {
        position: absolute;
        bottom: 0.4rem;
        left: 50%;
        width: 7rem;
        height: 0.9rem;
        border-radius: 0.45rem;
        background-color: #ec5d59;
        text-align: center;
        line-height: 0.9rem;
        color: #ffffff;
        transform: translateX(-50%);
      }
    }
  }
}
.fade {
  transition: all 0.4s;
}
.fade-in {
  opacity: 1 !important;
}
.fade-out {
  opacity: 0 !important;
}
.fade-up {
  transform: translateY(0);
}
.fade-down {
  transform: translateY(100%);
}
</style>
